<!--
  Renders the Resource - Media Mention app route
-->
<template>
  <!-- Inline styles to position the image in upper right corner -->
  <div data-e2e-id="cis-resource-partner" class="cis-resource-partner">
    <div class="cis-resource-partner__content">
      <!-- Featured Image -->
      <resource-heading v-bind:image="routeData.fields.featuredImage" />
      <!-- Title -->
      <resource-heading v-bind:title="routeData.fields.resourceTitle" />
      <!-- Content -->
      <resource-content v-bind:field="routeData.fields.resourceContent" />
      <!-- CTA -->
      <cta v-bind:field="routeData.fields.cta" />
      <!-- Placeholder - Resource Partner Content -->
      <div class="resourceContent">
        <sc-placeholder name="resource-partner-content" :rendering="rendering" />
      </div>
    </div>
    <div class="cis-resource-partner__bottom">
      <!-- Placeholder - Resource Partner Content -->
      <sc-placeholder name="resource-partner-content-bottom" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import ResourceContent from './CIS-ResourceContent.vue';
import ResourceHeading from './CIS-ResourceHeading.vue';
import Cta from './CIS-ResourceCTA.vue';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Partner',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ResourceContent,
    ResourceHeading,
    Cta,
    ScPlaceholder: Placeholder
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    }
  }
};
</script>

<style lang="scss" scoped>
.cis-resource-partner {
  &__content {
    color: $gray;
    padding-top: 7.2rem;
    padding-bottom: 0.8rem;
    @include padding-x-thin;

    .resourceContent {
      &:deep() {
        .c-rich-text {
          p,
          span,
          h2 {
            color: $gray;
          }

          h2 {
            background: none;
            -webkit-text-fill-color: $gray;
          }
        }
      }
    }
  }

  &:deep() {
    .resource-img {
      max-width: 100%;
      height: auto;
      margin-bottom: 4rem;
    }

    h1 {
      margin-bottom: 1rem !important;
    }

    .c-cta--primary {
      margin-top: 1rem;
    }

    .resource-content {
      margin-bottom: 0;
    }

    .c-content-gray-box {
      margin-bottom: 0;

      &__content {
        width: 100%;
        padding-left: 2rem;
        padding-right: 2rem;
        margin-left: auto;
        margin-right: auto;
        max-width: calc(1440px + 4rem);

        .c-cta--tertiary {
          padding-left: 0;
        }
      }
    }
  }
}
</style>
